import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from './../../services/elastic';
// External
import { Club } from './../../models/club';

import * as lodash from 'lodash';
import { ApiService } from './../../services/api';
import { DatePipe } from '@angular/common';


@Component({
    templateUrl: './website-terms-condition.component.html',
    selector: 'app-website-term-condition'
})
export class WebsiteTermConditionComponent implements OnInit {
    public imageLoader = true;
    
    public master = {
        text: ''
    };
    ngOnInit(): void {
        this.apiService.object("currentVersion/").then((result) => {
            if (result.tac){
                this.master.text = result['website-tac']
            }
            this.imageLoader =false
            
        })
    }
    constructor(private apiService: ApiService) {
    }
    public submit() {
        this.apiService.set("currentVersion/website-tac", this.master.text)
    }
}
